import { Logger, lodash } from "neo-common";
import { Platforms } from "neo-games";
import { HtmlButtonElement } from "./Elements/HtmlButtonElement";
import { HtmlElement } from "./Elements/HtmlElement";
import { UserAction } from "./UserAction";
import { HtmlContainerElement } from "./Elements/HtmlContainerElement";
import { AppContext } from "../../Common/AppContext";
import { GameManager } from "../Managers/GameManager";
import { ModuleManager } from "../Managers/ModuleManager";
import { BetManager } from "../Managers/BetManager";
import { PlayList } from "../Components/Sounds/PlayList";
import { GameApp } from "../GameApp";
import { BaseActions } from "../Channels/Common/Actions/BaseActions";
import { HtmlSoundContainerElement } from "./Custom/HtmlSoundContainerElement";
import { HtmlHideButtonElement } from "./Custom/HtmlHideButtonElement";
import { GameData } from "../Channels/Common/Datas/GameData";
import { DataManager } from "../Managers/DataManager";
import { Jackpot } from "../Channels/Common/Bonuses/Jackpot";
import { QuickspinDialog } from "../Channels/Common/Dialogs/QuickspinDialog";
import { Paytable } from "../Channels/Common/Paytable/Paytable";
import { BetHigherThanMinDialog } from "../Channels/Common/Dialogs/BetHigherThanMinDialog";

/**
 * Controller for html elements. Handle action dispatched from html elements.
 * @class HtmlController
 */
export class HtmlController {
    static Configurations = { SHOW_BONUS_BALANCE: false };
    static ActionElements: { [action: string]: Array<HtmlButtonElement> } = {};
    static UiActionElements: { [action: string]: Array<HtmlButtonElement> } = {};
    static UiDispatchElements: { [action: string]: Array<HtmlContainerElement> } = {};
    static UiActionDispatchElements: { [action: string]: Array<HtmlContainerElement> } = {};
    static ActionsHoldersElements: { [action: string]: Array<HtmlContainerElement> } = {};
    static ContainerElementsById: { [id: string]: HtmlContainerElement } = {};
    static DataElements: { [data: string]: Array<HtmlElement> } = {};
    static RidElements: Array<HtmlElement> = [];
    static DisabledClass: string = "_disabled";

    public static SoundContainer: HtmlSoundContainerElement;
    public static HideButtons: HtmlHideButtonElement[] = [];
    public static dispatchActionAllowed: boolean = true;

    /**
     * Register HtmlButtonElement and pair him with action.
     * @method registerActionElement
     * @param action string name of action
     * @param element HtmlButtonElement
     * @return void
     */
    static registerActionElement(action: string, element: HtmlButtonElement): void {
        if (DEBUG) {
            this.log("registerActionElement action: " + action);
        }

        if (this.ActionElements[action] == null) {
            this.ActionElements[action] = [];
        }
        this.ActionElements[action].push(element);
    }

    /**
     * Register HtmlButtonElement and pair him with ui action.
     * @method registerUiActionElement
     * @param action string name of action
     * @param element HtmlButtonElement
     * @return void
     */
    static registerUiActionElement(action: string, element: HtmlButtonElement): void {
        if (DEBUG) {
            this.log("registerUiActionElement action: " + action);
        }

        if (this.UiActionElements[action] == null) {
            this.UiActionElements[action] = [];
        }
        this.UiActionElements[action].push(element);
    }

    /**
     * Register HtmlContainerElement and pair him with ui disptacher.
     * @method registerUiActionElement
     * @param action string name of action
     * @param element HtmlButtonElement
     * @return void
     */
    static registerUiDispatchElement(action: string, element: HtmlContainerElement): void {
        if (DEBUG) {
            this.log("registerUiDispatchElement action: " + action);
        }

        if (this.UiDispatchElements[action] == null) {
            this.UiDispatchElements[action] = [];
        }
        this.UiDispatchElements[action].push(element);
    }

    static registerActionsHoldersElement(action: string, element: HtmlContainerElement): void {
        if (DEBUG) {
            this.log("registerActionsHoldersElement action: " + action);
        }

        if (this.ActionsHoldersElements[action] == null) {
            this.ActionsHoldersElements[action] = [];
        }
        this.ActionsHoldersElements[action].push(element);
    }

    /**
     * Register HtmlContainerElement and pair him with ui action disptacher.
     * @method registerUiActionElement
     * @param action string name of action
     * @param element HtmlButtonElement
     * @return void
     */
    static registerUiActionDispatchElement(action: string, element: HtmlContainerElement): void {
        if (DEBUG) {
            this.log("registerUiDispatchElement action: " + action);
        }

        if (this.UiActionDispatchElements[action] == null) {
            this.UiActionDispatchElements[action] = [];
        }
        this.UiActionDispatchElements[action].push(element);
    }

    /**
     * Register HtmlElement and pair him with some data id.
     * @method registerDataElement
     * @param data string name of data id
     * @param element HtmlElement
     * @return void
     */
    static registerDataElement(data: string, element: HtmlElement): void {
        if (DEBUG) {
            this.log("registerDataElement data: " + data);
        }

        if (this.DataElements[data] == null) {
            this.DataElements[data] = [];
        }
        this.DataElements[data].push(element);
    }

    /**
     * Dispatch action to controller.
     * @method dispatchAction
     * @param action string name of action
     * @return void
     */
    static dispatchAction(action: string): void {
        if (DEBUG) {
            this.log("dispatchAction action: " + action);
        }

        if (!HtmlController.dispatchActionAllowed) {
            return;
        }

        let updateUI: boolean = true;
        if (action === BaseActions.ActionDenomSelect) {
            updateUI = false;
            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.disable();
            }
            if (BetManager.BetContainer != null) {
                BetManager.BetContainer.disable();
            }
            if (HtmlController.SoundContainer != null) {
                HtmlController.SoundContainer.disable();
            }
            PlayList.play("SND_Click");
        }

        if (action === BaseActions.ActionCoinCountSelect) {
            updateUI = false;
            if (BetManager.DenomContainer != null) {
                BetManager.DenomContainer.disable();
            }
            if (BetManager.BetContainer != null) {
                BetManager.BetContainer.disable();
            }
            if (HtmlController.SoundContainer != null) {
                HtmlController.SoundContainer.disable();
            }
            PlayList.play("SND_Click");
        }

        if (action === BaseActions.ActionBetSelect) {
            updateUI = false;
            if (BetManager.DenomContainer != null) {
                BetManager.DenomContainer.disable();
            }
            if (BetManager.BetContainer != null) {
                BetManager.BetContainer.disable();
            }
            if (HtmlController.SoundContainer != null) {
                HtmlController.SoundContainer.disable();
            }
            PlayList.play("SND_Click");
        }

        if (AppContext.gameDefinition.ClientHostType === "Mobile") {
            switch (action) {
                case BaseActions.ActionBetPlus:
                    updateUI = false;
                    break;
                case BaseActions.ActionBetMinus:
                    updateUI = false;
                    break;
            }
        }

        if (updateUI) {
            this.dispatchUiAction("", action);
        }
        ModuleManager.dispatchAction(action);
    }

    static setSound(level: number): void {
        if (HtmlController.SoundContainer != null) {
            HtmlController.SoundContainer.setLevel(level);
            return;
        }

        for (var i: number = 0; i < HtmlController.UiActionElements[UserAction.ActionToggleSound].length; i++) {
            var ele: HtmlButtonElement = HtmlController.UiActionElements[UserAction.ActionToggleSound][i];
            if (ele.instance != null) {
                ele.instance.classList.remove("off");
                ele.instance.classList.remove("on1");
                ele.instance.classList.remove("on2");
                ele.instance.classList.remove("on3");

                switch (level) {
                    case 0:
                        ele.instance.classList.add("off");
                        PIXI.sound.volumeAll = 0;
                        Platforms.Platforms.setVolume(0);
                        break;
                    case 1:
                        ele.instance.classList.add("on1");
                        PIXI.sound.volumeAll = 0.25;
                        Platforms.Platforms.setVolume(1);
                        break;
                    case 2:
                        ele.instance.classList.add("on2");
                        PIXI.sound.volumeAll = 0.5;
                        Platforms.Platforms.setVolume(2);
                        break;
                    case 3:
                    default:
                        ele.instance.classList.add("on3");
                        PIXI.sound.volumeAll = 1;
                        Platforms.Platforms.setVolume(3);
                        break;
                }
            }
        }
    }

    /**
     * Dispatch ui action.
     * @method dispatchUiAction
     * @param action string name of action
     * @param originalAction string name of action
     * @return void
     */
    static dispatchUiAction(action: string, originalAction: string = ""): void {
        if (DEBUG) {
            this.log("dispatchUiAction action: " + action);
        }

        if (!HtmlController.dispatchActionAllowed) {
            return;
        }

        BetHigherThanMinDialog.closeDialog();

        Jackpot.closeAllHistoryDialogs();
        Platforms.Platforms.gameCloseMenu();

        if (action === "EMPTY") {
            PlayList.play("SND_Click");
            action = "";
        }

        var playSound: boolean = true;

        if (HtmlController.ContainerElementsById["autoplaySelector"]) {
            var autoplaySelector: HtmlContainerElement = HtmlController.ContainerElementsById["autoplaySelector"];
            if (
                autoplaySelector != null &&
                autoplaySelector.instance != null &&
                !autoplaySelector.instance.classList.contains("_disabled")
            ) {
                if (autoplaySelector.recalculateHeight) {
                    autoplaySelector.instance.removeAttribute("style");
                }
                autoplaySelector.instance.classList.add("_disabled");
            }
        }

        if (HtmlController.ContainerElementsById["autoplayDialog"]) {
            var autoplayDialog: HtmlContainerElement = HtmlController.ContainerElementsById["autoplayDialog"];
            if (
                autoplayDialog != null &&
                autoplayDialog.instance != null &&
                !autoplayDialog.instance.classList.contains("_disabled")
            ) {
                autoplayDialog.instance.classList.add("_disabled");
            }
        }

        if (BetManager.DenomContainer != null) {
            BetManager.DenomContainer.disable();
        }

        if (BetManager.CoinCountContainer != null) {
            BetManager.CoinCountContainer.disable();
        }
        if (action !== UserAction.ActionExit && DataManager.SimilarGames != null) {
            DataManager.SimilarGames.disable();
        }

        switch (action) {
            case "":
                DataManager.RulesWindowOpened = false;
                Paytable.close(originalAction);
                this.disableAllUiDispatchers(action);
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                playSound = false;
                break;
            case UserAction.ActionHelpTerminal:
                ModuleManager.cycleHelp();
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionGameRoundReport:
                HtmlController.dispatchUiAction("");
                GameApp.openGameRoundHistory(true);
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionExit:
                this.disableAllUiDispatchers(action);
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                if (DataManager.SimilarGames != null && DataManager.SimilarGames.enabled) {
                    if (DataManager.SimilarGames.open()) {
                        Paytable.close();
                    } else {
                        this.dispatchUiAction("");
                    }
                    if (HtmlController.SoundContainer != null) {
                        HtmlController.SoundContainer.disable();
                    }
                } else {
                    Platforms.Platforms.exitHandler = "exitBtn";
                    GameApp.exit();
                }
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionExit + "2":
                Platforms.Platforms.exitHandler = "similarGamesExitBtn";
                GameApp.exit();
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionToggleSound:
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.toggle();
                } else {
                    if (HtmlController.UiActionElements[UserAction.ActionToggleSound] != null) {
                        for (
                            var i: number = 0;
                            i < HtmlController.UiActionElements[UserAction.ActionToggleSound].length;
                            i++
                        ) {
                            var ele: HtmlButtonElement =
                                HtmlController.UiActionElements[UserAction.ActionToggleSound][i];
                            if (ele.instance != null) {
                                if (ele.instance.classList.contains("off")) {
                                    ele.instance.classList.remove("off");
                                    ele.instance.classList.add("on3");
                                    PIXI.sound.volumeAll = 1;
                                    AppContext.current.setVolume(3);
                                    Platforms.Platforms.setVolume(3);
                                } else if (ele.instance.classList.contains("on1")) {
                                    ele.instance.classList.remove("on1");
                                    ele.instance.classList.add("off");
                                    playSound = false;
                                    PIXI.sound.volumeAll = 0;
                                    AppContext.current.setVolume(0);
                                    Platforms.Platforms.setVolume(0);
                                } else if (ele.instance.classList.contains("on2")) {
                                    ele.instance.classList.remove("on2");
                                    ele.instance.classList.add("on1");
                                    PIXI.sound.volumeAll = 0.25;
                                    AppContext.current.setVolume(1);
                                    Platforms.Platforms.setVolume(1);
                                } else if (ele.instance.classList.contains("on3")) {
                                    ele.instance.classList.remove("on3");
                                    ele.instance.classList.add("on2");
                                    PIXI.sound.volumeAll = 0.5;
                                    AppContext.current.setVolume(2);
                                    Platforms.Platforms.setVolume(2);
                                }
                            }
                        }
                    }
                }
                break;
            case UserAction.ActionToggleBet:
                DataManager.RulesWindowOpened = false;
                Paytable.close();
                this.disableAllUiDispatchers(action);
                this.toggleUiAction(action, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                break;
            case UserAction.ActionTogglePaytable:
                this.toggleUiAction(action, "toggle");
                this.toggleUiAction(UserAction.ActionHelpOn, "add");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                Paytable.instance.updateDataValues();
                break;
            case UserAction.ActionToggleMenu:
                DataManager.RulesWindowOpened = false;
                this.toggleUiAction(action, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "add");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "remove");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionToggleMenuBack:
                this.toggleUiAction(UserAction.ActionToggleMenu, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionHelpOn:
                DataManager.RulesWindowOpened = true;
                this.disableAllUiDispatchers(action);
                this.toggleUiAction(action, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "add");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                Platforms.Platforms.gotoHelp();
                break;
            case UserAction.ActionHelpOff:
                DataManager.RulesWindowOpened = false;
                this.disableAllUiDispatchers(action);
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionPaytableOn:
                DataManager.RulesWindowOpened = true;
                this.disableAllUiDispatchers(action);
                this.toggleUiAction(action, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "add");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "remove");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                Platforms.Platforms.gotoPaytable();
                Paytable.instance.updateDataValues();
                break;
            case UserAction.ActionPaytableOff:
                DataManager.RulesWindowOpened = false;
                Paytable.close();
                this.disableAllUiDispatchers(action);
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionSwitchControls:
                let body = document.body;
                if (body.classList.contains("reverse")) {
                    body.classList.remove("reverse");
                } else {
                    body.classList.add("reverse");
                }
                break;
            case UserAction.ActionSettingsOn:
                this.disableAllUiDispatchers(action);
                this.toggleUiAction(action, "toggle");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                Platforms.Platforms.gotoSettings();
                break;
            case UserAction.ActionSettingsOff:
                this.disableAllUiDispatchers(action);
                this.changeUiAcionDispatchers(UserAction.ActionMenuOn, "remove");
                this.changeUiAcionDispatchers(UserAction.ActionMenuOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionHelpOff, "add");
                this.changeUiAcionDispatchers(UserAction.ActionPaytableOff, "add");
                if (HtmlController.SoundContainer != null) {
                    HtmlController.SoundContainer.disable();
                }
                break;
            case UserAction.ActionQuickspinDialogOff:
                QuickspinDialog.closeDialog();
                break;
            case UserAction.ActionQuickspinToggle:
                DataManager.quickspinSet();
                break;
            case UserAction.ActionVibrationToggle:
                DataManager.vibrationSet();
                break;
            default:
                if (DEBUG) {
                    this.log("No element with ui disptacher: " + action);
                }
        }

        if (playSound) {
            PlayList.play("SND_Click");
        }
    }

    /**
     * Disable all ui dispatcher at once.
     * @method disableAllUiDispatchers
     * @param action string name of action
     * @return void
     */
    private static disableAllUiDispatchers(action: string): void {
        for (var key in this.UiDispatchElements) {
            for (var i: number = 0; i < this.UiDispatchElements[key].length; i++) {
                if (
                    this.UiDispatchElements[key][i].instance.classList.contains(HtmlController.DisabledClass) ===
                        false &&
                    key != action
                ) {
                    this.UiDispatchElements[key][i].instance.classList.add(HtmlController.DisabledClass);
                    if (this.UiActionDispatchElements[key] != null) {
                        for (var j: number = 0; j < this.UiActionDispatchElements[key].length; j++) {
                            this.UiActionDispatchElements[key][j].instance.classList.toggle(
                                HtmlController.DisabledClass,
                            );
                        }
                    }
                }
            }
        }
    }

    /**
     * Toggle disable for specific UI dispatcher.
     * @method changeUiAcionDispatchers
     * @param action string name of action
     * @param type string
     * @return void
     */
    private static changeUiAcionDispatchers(action: string, type: string): void {
        if (this.UiActionDispatchElements[action] != null) {
            for (var i: number = 0; i < this.UiActionDispatchElements[action].length; i++) {
                if (type === "add") {
                    if (
                        this.UiActionDispatchElements[action][i].instance.classList.contains(
                            HtmlController.DisabledClass,
                        ) === false
                    ) {
                        this.UiActionDispatchElements[action][i].instance.classList.add(HtmlController.DisabledClass);
                    }
                } else if (type === "remove") {
                    this.UiActionDispatchElements[action][i].instance.classList.remove(HtmlController.DisabledClass);
                } else {
                    this.UiActionDispatchElements[action][i].instance.classList.toggle(HtmlController.DisabledClass);
                }
            }
        }
    }

    /**
     * Toggle disable for specific UI action.
     * @method toggleUiAction
     * @param action string name of action
     * @param type string
     * @return void
     */
    private static toggleUiAction(action: string, type: string): void {
        if (this.UiDispatchElements[action] != null) {
            for (var i: number = 0; i < this.UiDispatchElements[action].length; i++) {
                if (type === "add") {
                    if (
                        this.UiDispatchElements[action][i].instance.classList.contains(HtmlController.DisabledClass) ===
                        false
                    ) {
                        this.UiDispatchElements[action][i].instance.classList.add(HtmlController.DisabledClass);
                    }
                } else if (type === "remove") {
                    this.UiDispatchElements[action][i].instance.classList.remove(HtmlController.DisabledClass);
                } else {
                    this.UiDispatchElements[action][i].instance.classList.toggle(HtmlController.DisabledClass);
                }
            }
        }
    }

    /**
     * Update all elements with one data id.
     * @method updateDataElement
     * @param data string data id
     * @param value string value for this data id
     * @return void
     */
    static updateDataElement(data: string, value: string): void {
        if (this.DataElements[data] != null) {
            for (var i: number = 0; i < this.DataElements[data].length; i++) {
                HtmlController.currencyNoZero(data, value);
                this.DataElements[data][i].setText(value);
            }
        } else {
            if (DEBUG) {
                this.log("No element with data id: " + data);
            }
        }
    }

    /**
     * Update all elements which has set some data id.
     * @method updateDataElements
     * @param gameData Object
     * @return void
     */
    static updateDataElements(gameData: { [data: string]: string }): void {
        if (DEBUG) {
            this.log("udpateDataElements");
        }

        for (var key in gameData) {
            if (this.DataElements[key] != null) {
                for (var i: number = 0; i < this.DataElements[key].length; i++) {
                    HtmlController.currencyNoZero(key, gameData[key]);
                    this.DataElements[key][i].setText(gameData[key]);
                }
            } else {
                if (DEBUG) {
                    this.log("No element with data id: " + key);
                }
            }
        }
    }

    static currencyNoZero(data: string, value: string): void {
        let parsedValue: number;

        if (value === "") {
            parsedValue = 0;
        } else {
            parsedValue = parseFloat(value);
        }

        if (data === GameData.DataTotalWin) {
            if (parsedValue === 0) {
                HtmlController.toggleElementsByClass("currencyNoZero");
            } else {
                HtmlController.toggleElementsByClass("currencyNoZero", true);
            }
        } else if (data === GameData.DataGambleColorWin) {
            if (parsedValue === 0) {
                HtmlController.toggleElementsByClass("gambleCurrencyNoZero");
            } else {
                HtmlController.toggleElementsByClass("gambleCurrencyNoZero", true);
            }
        }
    }

    static toggleElementsByClass(cls: string, show: boolean = false): void {
        var elements: HTMLCollectionOf<Element> = document.getElementsByClassName(cls);
        for (var i: number = 0; i < elements.length; i++) {
            var element: HTMLElement = <HTMLElement>elements[i];
            if (element != null) {
                if (show) {
                    element.style.display = "";
                } else {
                    element.style.display = "none";
                }
            }
        }
    }

    /**
     * Update all elements which has set some action id.
     * @method updateActionElements
     * @param actionData Object
     * @return void
     */
    static updateActionElements(actionData: Object): void {
        if (DEBUG) {
            this.log("updateActionElements");
        }

        for (var key in actionData) {
            if (this.ActionElements[key] != null) {
                var i: number;
                for (i = 0; i < this.ActionElements[key].length; i++) {
                    this.ActionElements[key][i].changeState(actionData[key]);
                }

                if (this.ActionsHoldersElements[key] != null) {
                    for (i = 0; i < this.ActionsHoldersElements[key].length; i++) {
                        this.ActionsHoldersElements[key][i].changeState(actionData[key]);
                    }
                }
            } else {
                if (DEBUG) {
                    var keys = lodash.keys(this.ActionElements).join(";");

                    this.log("No element with data id: " + key + ", current keys: " + keys);
                }
            }
        }
    }

    static updateActionElement(key: string, value: boolean): void {
        var i: number;
        if (this.ActionElements[key] != null) {
            for (i = 0; i < this.ActionElements[key].length; i++) {
                this.ActionElements[key][i].changeState(value);
            }
        }

        if (this.ActionsHoldersElements[key] != null) {
            for (i = 0; i < this.ActionsHoldersElements[key].length; i++) {
                this.ActionsHoldersElements[key][i].changeState(value);
            }
        }
    }

    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("HtmlController", data);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/HtmlController.ts
 **/